import {
  FaBriefcase,
  FaCalendarAlt,
  FaRegNewspaper,
  FaPowerOff,
  FaGooglePlay,
} from "react-icons/fa";
import { GrVmMaintenance } from "react-icons/gr";
import { MdEditSquare } from "react-icons/md";
import { IoFootsteps } from "react-icons/io5";
import { Link } from "react-router-dom";
import Wrapper from "../../assets/wrappers/Job";
import BuildingInfo from "../Building/BuildingInfo.jsx";
import day from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
day.extend(advancedFormat);

const OfficeBuilding = ({
  _id,
  city,
  street,
  houseNumber,
  maintenanceCompany,
  createdAt,
  rssNewsPath,
  workOnSaturday,
  nickname,
  screenStatus,
}) => {
  const date = day(createdAt).format("DD.MM.YYYY");
  return (
    <Wrapper>
      <header>
        <div style={{ marginRight: "10px", height: "30px" }}>
          <Link to={`../add-floor/${_id}`} className="btn edit-btn">
            <MdEditSquare />
          </Link>
        </div>
        <div className="info">
          <h5>
            {city} , {street} {houseNumber}
          </h5>
          <p>{nickname}</p>
        </div>
      </header>
      <div className="content">
        <div className="content-center">
          <BuildingInfo
            icon={<FaCalendarAlt />}
            text={date}
            tooltip="תאריך יצירה"
          />
          <BuildingInfo
            icon={<FaRegNewspaper />}
            text={rssNewsPath}
            tooltip="חדשות בתחתית המסך"
          />
          {maintenanceCompany && (
            <BuildingInfo
              icon={<GrVmMaintenance />}
              text={
                maintenanceCompany.name +
                " " +
                (maintenanceCompany.lastName || "")
              }
            />
          )}
        </div>
        <footer className="actions">
          <Link
            style={{ background: "#5E936C"}}
            to={`../add-floor/${_id}`}
            className="btn edit-btn"
          >
            <IoFootsteps />
          </Link>
          <Link
            style={{ background: "#c90c35ff", marginRight: "auto" }}
            to={`/office/${_id}`}
            className="btn edit-btn"
          >
            <FaGooglePlay />
          </Link>
        </footer>
      </div>
    </Wrapper>
  );
};

export default OfficeBuilding;
